export default {
        ABU_DHABI_MARKET: 'abuDhabiMarket'
};